import { ENVIRONMENT } from '~/constants';

/** @description 디버그 페이지로 이동하는 훅 */
export const useMoveToDebug = () => {
  const showBackDoorFeature = ['development', 'staging', 'qa'].includes(ENVIRONMENT ?? '');
  const isWebView = Boolean(window?.JSBridge) || Boolean(window?.webkit);

  const handleMoveToDebug = () => {
    if (window?.JSBridge) {
      window.JSBridge.moveToDebug();
    }

    if (window?.webkit) {
      window.webkit.messageHandlers.moveToDebug.postMessage(null);
    }
  };

  return {
    showDebugButton: showBackDoorFeature && isWebView,
    handleMoveToDebug,
  };
};

export default useMoveToDebug;
